import { Select } from "antd";

export const SearchBasicSelectUI = ({ data, ...restProps }) => {
  return (
    <Select
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={data}
      {...restProps}
    />
  );
};
